import ReactGA from 'react-ga';

export const initializeGA = (userId) => {
  ReactGA.initialize(process.env.GA_TOKEN);
  ReactGA.set({ dimension1: userId });
};

export const simpleTrack = (view) => {
  const prefix = process.env.NODE_ENV === 'production' ? '' : `[${process.env.NODE_ENV}] `;
  const page = `${prefix}Page - ${view}`;

  ReactGA.ga('send', 'pageview', { page });
};

export const gaSendEvent = (category, action, label) => {
  ReactGA.event({ category, action, label });
};
